import { FC } from 'react'
import { styled } from '@portfolio/styles'

type TableRow = {
  _key: string
  cells?: string[]
}

type TableBlockProps = {
  value?: {
    table?: {
      rows?: TableRow[]
    }
  }
}

const ScrollWrapper = styled('div', {
  overflowX: 'auto',
  width: '100vw',
  marginLeft: 'calc(-50vw + 50%)',
  paddingLeft: 'calc(50vw - 50%)',
  paddingRight: 'calc(50vw - 50%)',

  '@md': {
    width: 'auto',
    marginLeft: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
})

const StyledTable = styled('table', {
  width: '100%',
  borderCollapse: 'collapse',
})

const StyledTh = styled('th', {
  backgroundColor: '$gray50',
  padding: '$16 $20',
  textAlign: 'left',
  verticalAlign: 'middle',
  projectFont: 'tableHeading',
  color: '$black',
  minWidth: '$144',
})

const StyledTr = styled('tr', {
  borderBottom: '1px solid $gray200',
})

const StyledTd = styled('td', {
  padding: '$16 $20',
  verticalAlign: 'top',
  textAlign: 'left',
  projectFont: 'tableCell',
  color: '$gray400',
})

export const Table: FC<TableBlockProps> = ({ value }) => {
  if (!value?.table?.rows?.length) return null

  const [headerRow, ...bodyRows] = value.table.rows

  return (
    <ScrollWrapper>
      <StyledTable>
        {headerRow?.cells && (
          <thead>
            <tr>
              {headerRow.cells.map((cell, index) => (
                <StyledTh scope="col" key={`${cell}-${index}`}>
                  {cell}
                </StyledTh>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {bodyRows.map((row) => (
            <StyledTr key={row._key}>
              {row?.cells?.map((cell, index) => (
                <StyledTd key={`${cell}-${index}`}>{cell}</StyledTd>
              ))}
            </StyledTr>
          ))}
        </tbody>
      </StyledTable>
    </ScrollWrapper>
  )
}
